import { getImgURL } from '@shared-submodule/utils'
import MyImage from '@shared/components/myImage'
import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'
import useWindowSize from '@shared/hooks/windowSize'

function ChessInterestingReads({ data, isMobile = false }) {
  const [width] = useWindowSize()

  return (
    <div className={`container ${styles.highlight} px-0`}>
      <div className="widget-title  d-flex justify-content-between align-items-center">
        <h3 className="small-head d-flex align-items-center  mb-0">
          <span>Editors Picks</span>
        </h3>
      </div>
      <div className={`container ${styles.interesting_cards} px-0`}>
        {data?.map((a, i) => {
          return (
            <CustomLink key={i} href={isMobile ? `/${a?.oSeo?.sSlug}/mobile` : `/${a?.oSeo?.sSlug}`}>
              <div className={`cursor-pointer ${styles.cards}`}>
                <div className={`${styles.cardsImage} d-block block-img`}>
                  <MyImage src={getImgURL(a?.oImg?.sUrl)} layout="responsive" alt="Read 1" width={300} height={200} />
                </div>
                {width > 992 ? (
                  <p style={{ minHeight: '40px' }}>{a.sSrtTitle.length > 70 ? `${a.sSrtTitle.slice(0, 70)}...` : a?.sSrtTitle}</p>
                ) : (
                  <p style={{ minHeight: '40px' }}>{a.sSrtTitle.length > 55 ? `${a.sSrtTitle.slice(0, 55)}...` : a?.sSrtTitle}</p>
                )}
              </div>
            </CustomLink>
          )
        })}
      </div>
    </div>
  )
}

ChessInterestingReads.propTypes = {
  data: PropTypes.array,
  isMobile: PropTypes.bool
}

export default ChessInterestingReads
